module.exports = __webpack_public_path__ + "img/icon_cailiao@2x.aca81132.png";